module.exports = __webpack_public_path__ + "img/0Q3B8222_Wood_MockedUp.06581a29.jpg";